import { ComponentManager, UIInterceptor } from "radpresentation.htmlclient.defaultviewextensions";
import WorkflowUtility from '@/Utility/WorkflowUtility';

export default class WFEUIInterceptor extends UIInterceptor {
    constructor() {
        super();
    }

    public beforeLoadMenuTree(rootNode: any): any {
        this.handleLinks(rootNode, link => link.IsMenuRelevant === true);
    }

    public beforeLoadNavigationTree(rootNode: any): any {
        this.handleLinks(rootNode, link => link.IsNavigationTreeRelevant === true);
    }

    private handleLinks(rootNode: any, predicate: any): any {
        let workflowExecutionLinkContainerDTO = WorkflowUtility.getWorkflowContainerDto();
        if (workflowExecutionLinkContainerDTO != null) {
            for (let i = 0; i < workflowExecutionLinkContainerDTO.Links.length; i++) {
                (workflowExecutionLinkDTO => {
                    if (predicate(workflowExecutionLinkDTO)) {
                        let node = this.findNavigationNode(rootNode, workflowExecutionLinkDTO);
                        if (node != null) {
                            node.childNodes.push({
                                childNodes: [],
                                name: workflowExecutionLinkDTO.Name,
                                caption: workflowExecutionLinkDTO.GuiLabelMLS,
                                iconUrl: workflowExecutionLinkDTO.IconUrl,
                                action: 'CUSTOM_ACTION',
                                actionCallback: () => WorkflowUtility.startWorkflowWithPdoId(workflowExecutionLinkDTO.PDWorkflowMetaPDO_ID)
                            });
                        }
                    }
                })(workflowExecutionLinkContainerDTO.Links[i]);
            }
        }
    }

    private findNavigationNode(node: any, link: any): any {
        let paths = link.Path.split('.');
        let root = node;
        for (let i = 0; i < paths.length; i++) {
            let newRoot = null;
            let path = paths[i];
            for (let j = 0; j < root.childNodes.length; j++) {
                let child = root.childNodes[j];
                if (child.name === path) {
                    newRoot = child;
                    break;
                }
            }
            if (newRoot == null) {
                break;
            }
            root = newRoot;
        }
        return root;
    }
}

ComponentManager.setUIInterceptor('WFEUIInterceptor', WFEUIInterceptor, 'WorkflowEngineHTMLViewExtension');